/*========================================================================
* $Id$
*
* Copyright © Mindbreeze Software GmbH, Linz, Austria, 2005-2013
*
* Der Nutzer des Computerprogramms anerkennt, dass der oben stehende
* Copyright-Vermerk im Sinn des Welturheberrechtsabkommens an der vom
* Urheber festgelegten Stelle in der Funktion des Computerprogramms
* angebracht bleibt, um den Vorbehalt des Urheberrechtes genuegend zum
* Ausdruck zu bringen. Dieser Urheberrechtsvermerk darf weder vom Kunden,
* Nutzer und/oder von Dritten entfernt, veraendert oder disloziert werden.
* =========================================================================*/

define([
    "i18n/i18n",
    "editors/template/js/template",
    "editors/schema/js/schema",
    "editors/actions/js/actions",
    "client/layouttree",
    "client/templateregistry",
    "client/schema",
    "utils/url",
    "editors/adder/js/adder",
    "underscore",
    "backbone",
    "api/v2/resources", 
    "service/channels", 
    "utils/browser",
    "utils/uuid",
    "jquery",
    "component!results",

    "component!row",
    "component!anchor",
    "component!searchform",
    "component!filteredfacet",
    "component!pages",
    "component!pagination",
    "component!charts",
    "component!search",
    "component!searchdesigner",
    "component!summarize",
    "component!chatframe",
    "component!module"
  ],
  function(
    i18n,
    TemplateEditor,
    SchemaEditor,
    ActionsView,
    LayoutTree,
    TemplateRegistry,
    Schema,
    url,
    Picker,
    _,
    Backbone,
    Resources,
    Channels, 
    browser,
    UUID,
    $,
    ResultsTemplate
  ) {

    var Editor = function (application, callback) {
      this.application = application;
      window.editor = this;

      var containerEl = this.application.options.containerEl;
      // $(containerEl).addClass("editor-enabled mb-body mb-has-components mb-editable");
      $(containerEl).addClass("editor-enabled mb-body mb-editable");

      this.application.on("stopEditing", this.remove, this);
      this.application.models.search.on("computed", function () {
        // console.log("if layout select parent element as default selected element...");
        // fix for drag&drop after insert layout element
        var selectedElement = $('.mb-selected');
        var addButtonElement = $(".mb-component-container") && $(".mb-component-container").find(".mb-add");
        if (addButtonElement && addButtonElement.length > 0) {
          var element = addButtonElement[addButtonElement.length - 1];          
          element && element.click({el: element});
        }
        selectedElement.addClass("mb-selected");
      });

      var saveMode = /^true$/i.test(browser.getURLParameter("saveMode")) || /^\/designer\//i.test(window.location.pathname);
      var disableHeader = /^false$/i.test(browser.getURLParameter("header"));
      if (disableHeader) $('body').addClass("disable-header");

      var hideGlobalSaveModule = this.application.options.experimentalUseModulesInDesigner !== true;
      this.globalActions = new Backbone.Collection([
        { "id": "editor_global_save",  "label": "editor_save_module", "icon": "icon-save", "hidden": hideGlobalSaveModule},
        { "id": "editor_edit_module_properties",  "label": "editor_edit_module_properties", "icon": "icon-pencil", "hidden": true},
        { "id": "editor_global_new",  "label": "editor_new", "icon": "icon-pencil", "hidden": true},
        { "id": "editor_generate_embedded_code",  "label": "editor_generate_embedded_code", "icon": "icon-code", "hidden": saveMode},
        { "id": "editor_publish_code",  "label": "publish", "icon": "icon-share", "hidden": !saveMode},
      ]);
      
      if (saveMode) {
        this.initResources(callback);
      } else {
        this.createModalSnippet();
        this.addActions();
        this.refresh(callback);
      }
    };

    _.extend(Editor.prototype, Backbone.Events, {
        create: function () {
          this.el = document.createElement("div");
          this.el.className = "editor mb-inline-editor";
          this.formEl = document.createElement("form");

          $(this.formEl).on("submit", function (e) {
            e.stopPropagation();
            return false;
          });
          this.el.appendChild(this.formEl);

          // for the content
          this.editorEl = document.createElement("div");
          this.editorEl.className = "main-editor-view mb-scrollable-y";
          this.formEl.appendChild(this.editorEl);

          this.getContainerWrappedElementByGivenElement('#categoryEditor').append(this.el);
        },

        save: function () {
          if (this.templateEditor.update()) {
            this.refresh();
          }
        },

        isAppFragmentExportType: function () {
          return this.application.options
          && this.application.options.exprEnvironment
          && this.application.options.exprEnvironment['designerExportType']
          && this.application.options.exprEnvironment['designerExportType'] === 'AppFragment';
        },

        prepareAppData: function(reponseHTMLData) {
          if (this.isAppFragmentExportType()) {
            var wrapContent = '<div class="mb-progress-bar mb-fixed"></div> '  +
            '<div data-template="view" data-count="5" data-constraint="ALL" class="testttt"> ' +
              '<div class="mb-component-container container " id="mb-component-container"> ' + reponseHTMLData + ' </div>'
            '</div>'

            return wrapContent;
          }

          return reponseHTMLData;
        },

        initResources: function(callback) {
          var that = this;
          $(document.body).addClass("save-mode");

          var storeURL = browser.getURLParameter("storeURL") || "";

          this.res = new Resources.ServiceFactory();
          this.filename = browser.getURLParameter("filename");
          this.resourceChannels = new Channels([ storeURL + "/adminapps/services/"]);

          if (!this.filename) {
            var match = window.location.pathname.match(/^\/designer\/([^\/]*)\//);
            this.filename = match && "app_" + match[1] + "_snippet.html";
          }
          if (!this.filename) {
            window.location.search = "saveMode=true&filename=" + "app_" + 
            encodeURIComponent(UUID.generate()) + "_snippet.html&storeURL=" + 
            encodeURIComponent(storeURL);
          }

          this.res.get(this.filename, function(data, errors) {
            if (data) { 
              that.getContainerWrappedElementByGivenElement(".mb-snippet-source").html(that.prepareAppData(data));
            }

            that.createModalSnippet();
            that.addActions();
            that.refresh(callback);

          }, this.resourceChannels);
        },

        /**
         *  reload method calls updateSnippet and it saves the snippet into application.snippet
         *  computing and/or manipulatings snippets outside of reload includes already transformed template elements.
         */
        saveSearchapp: function() {
          this.application.reload();  
          this.res.put(this.filename, this.application.snippet, this.resourceChannels);
        },

        getContainerWrappedElementByGivenElement: function(element) {
          if (element) {
            return $(this.application.options.containerEl).find(element);
          }
          return this.application.options.containerEl;
        },

        // TODO: make a datastructure for the current editor
        // so that we can replace the complete state.
      
        displayEditor: function (template) {
          var that = this,
              // TODO: reference search directly? deactivate all models?
              model = this.application.models.search;

          this.remove();

          if (!template || !template.editable) {
            return;
          }
          this.create();
          $(template.el).addClass("mb-selected");
          this.templateEditor = new TemplateEditor({value: template, model: model});
          this.templateEditor.render();
          this.templateEditor.on("change", function () {
            that.save();
          });
          if (this.renderedActionsView != this.actionsView) {
            this.renderActions(this.actionsView);
          }
          this.editorEl.appendChild(this.templateEditor.el);
        },

        displayAppFragmentEditor: function (appFragment, options) {
          options = options || {};
          var appFragmentSchema = new Schema({
            attributes: {
              type: {
                type: "string",
                title: "editor_app_fragment_type",
                // "default": false
              },
              name: {
                type: "string",
                title: "editor_app_fragment_name",
                // "default": false
              },
              title: {
                type: "string",
                title: "editor_app_fragment_title",
                // "default": false
              },
              description: {
                type: "text",
                title: "editor_app_fragment_description",
                // "default": false
              },
              htmlFragment: {
                type: "text",
                title: "editor_app_fragment_html",
                // "default": false
              },
              schema: {
                type: "text",
                title: "editor_app_fragment_schema",
                // "default": false
                format: "json"
              },
            }
          });

        
          var that = this;

          if (!appFragment) {
            appFragment = {
              htmlFragment: ""
            };
          }
          var editedAppFragmentJson = _.extend({}, appFragment);
          editedAppFragmentJson.htmlFragment = this.application.appFragmentHtmlSnippet

          var oldEditor = this.templateEditor;
          var store = new SchemaEditor.Store(editedAppFragmentJson, {schema: appFragmentSchema,
                                                                     legend: options.title || (i18n("editor_edit_module") + (appFragment.title ? " " + appFragment.title : "")) });
          if (!oldEditor) {
            this.remove();
            this.create();
          }
          var dirty = false;
          var actionsCollection = new Backbone.Collection([
            {id: "editor_cancel", "label": "editor_cancel"},
            {id: "editor_save", "label": "editor_save_module", },
          ]);
          var actionsView = new ActionsView({collection: actionsCollection});
          var that = this;


          function restoreState() {
            if (oldEditor) {
              var currentEditor = that.templateEditor;
              that.templateEditor = oldEditor;
              currentEditor.el.replaceWith(oldEditor.el);
            }
            else {
              that.clear();
            }
            that.renderActions(that.actionsView.render());
          }

          actionsView.on("click", function(actionModel, e, view) {
            // var editedObj = editedAppFragment;
            if (actionModel.get("id") == "editor_save") {
              that.saveAppFragmentJsonAsync(editedAppFragmentJson)
                .then(function (value) {
                  dirty = false;
                  that.loadAppFragment(editedAppFragmentJson);
                  restoreState();
                })
                .catch(function (err) {
                  alert("Failed to save app " + editedAppFragmentJson.id + " error: " + err);
                });              
            }
            else {
              restoreState();
            }
          });
          this.renderActions(actionsView.render());
          this.templateEditor = new SchemaEditor({store: store});
          this.templateEditor.on("change", function () {
            that.templateEditor.update();
            dirty = true;
          });

          this.templateEditor.render();
          if (oldEditor) {
            oldEditor.el.replaceWith(this.templateEditor.el);
          } else {
            this.editorEl.appendChild(this.templateEditor.el);
          }
        },

      
        createModalSnippet: function() {
          var container = this.getContainerWrappedElementByGivenElement(this.application.options.rootEl);
          var model = 
          '<div class="modal hide" id="modal_snippet">\
            <div class="modal-dialog">\
              <div class="modal-content">\
                <div class="modal-header">\
                  <button type="button" class="close icon-remove" data-dismiss="modal" aria-hidden="true"></button>\
                  <i class="fa fa-code"></i>\
                  <script type="text/x-mustache-template" data-tag-name="h4" data-class-name="modal-title">\
                    {{{i18n.editor_export_title}}}\
                  </script>\
                  <script type="text/x-mustache-template" data-tag-name="p" data-class-name="modal-title">\
                    {{{i18n.editor_export_help}}}\
                  </script>\
                </div>\
                <div class="modal-body">\
                    <textarea class="mb-snippet-target"></textarea>\
                </div>\
                <div class="modal-footer">\
                  <span class="btn btn-white" onclick="return editor.copyCodeSnippet()">\
                    <i class="fa fa-copy"></i>\
                    <script type="text/x-mustache-template" data-tag-name="span">\
                      {{i18n.Copy}}\
                    </script>\
                  </span>\
                </div>\
              </div>\
            </div>\
          </div>';
          $(container).append(model);
        },

        handleActionClick: function(actionModel, e, view) {
          if (actionModel.get("id") == "editor_generate_embedded_code") {
            // TODO handle this.
            this.exportReload();
            // TODO what is data-toggle="modal"
          }
          if (actionModel.get("id") == "editor_publish_code") {
            this.saveSearchapp();
          }
          if (actionModel.get("id") == "editor_global_new") {
            if (confirm("Are you sure to reset editor?")) {
              this.clearAppFragment();
            }
          }
          if (actionModel.get("id") == "editor_global_save") {
            // save as module
            if (!this.application.options.editAppFragmentJson || !this.application.options.editAppFragmentJson.id) {
              this.displayAppFragmentEditor(null, {title: i18n("editor_save_module_as")});
            }
            else {
              // just save
              var that = this;
              var editedAppFragmentJson = _.extend({}, this.application.options.editAppFragmentJson);
              editedAppFragmentJson.htmlFragment = this.application.appFragmentHtmlSnippet;
              this.saveAppFragmentJsonAsync(editedAppFragmentJson)
                .then(function (value) {
                  that.loadAppFragment(editedAppFragmentJson);
                })
                .catch(function (err) {
                  alert("Failed to save app " + editedAppFragmentJson.id + " error: " + err);
                });              
            }
          }
          if (actionModel.get("id") == "editor_edit_module_properties") {
            this.displayAppFragmentEditor(this.application.options.editAppFragmentJson);
          }

        },


        renderActions: function(actionsView) {
          var container = this.getContainerWrappedElementByGivenElement("#mb-actions-container");
          container.html("");
          $(container).append(actionsView.el);
          this.renderedActionsView = actionsView;
        },
      
        addActions: function() {
          if (this.actionsView) {
            this.stopListening(this.actionsView);
            this.actionsView.remove();
          }
          this.actionsView = new ActionsView({collection: this.globalActions});
          this.listenTo(this.actionsView, "click", this.handleActionClick);
          this.renderActions(this.actionsView.render());
          return;
        },
      
        addModuleInputFields: function(appFragment) {
          appFragment = appFragment || {}
          var snippet = 
              '<div class="template">\
                  <legend>' + i18n("editor_create_new_module") + '</legend>\
                  <div class="attribute">\
                    <label for="name" class="attribute-label">' + i18n("editor_module_type") + '</label>\
                    <div><span class="value-editor"><input value="' + (appFragment.type || '') + '" id="create-module-type" type="text"></span></div>\
                  </div>\
                  <div class="attribute">\
                    <label for="name" class="attribute-label">' + i18n("editor_module_name") + '</label>\
                    <div><span class="value-editor"><input value="' + (appFragment.name || '') + '" id="create-module-name" type="text"></span></div>\
                  </div>\
                  <div class="attribute">\
                    <label for="name" class="attribute-label">' + i18n("editor_module_title") + '</label>\
                    <div><span class="value-editor"><input value="' + (appFragment.title || '') + '" id="create-module-title" type="text"></span></div>\
                  </div>\
                  <div class="attribute full-width">\
                    <label for="llm-prompt-instruction-text" class="attribute-label">' + i18n("editor_module_description") + '</label>\
                    <div>\
                      <button class="checked btn"><i class="icon-ok"></i></button>\
                      <span class="value-editor"><textarea id="create-module-description">' + (appFragment.description || '') + '</textarea></span>\
                    </div>\
                  </div>\
                  <div class="attribute full-width">\
                    <label for="llm-prompt-instruction-text" class="attribute-label">' + i18n("editor_module_htmlSnippet") + '</label>\
                    <div>\
                      <button class="checked btn"><i class="icon-ok"></i></button>\
                      <span class="value-editor"><textarea id="create-module-html">' + (appFragment.htmlFragment || '') + '</textarea></span>\
                    </div>\
                  </div>\
                  <div class="attribute full-width">\
                    <label for="llm-prompt-instruction-text" class="attribute-label">' + i18n("editor_module_schema") + '</label>\
                    <span id="schema-error-txt" class="error-text"></span>\
                    <div>\
                      <button class="checked btn"><i class="icon-ok"></i></button>\
                      <span class="value-editor"><textarea id="create-module-schema">' + (JSON.stringify(appFragment.schema) || '') + '</textarea></span>\
                    </div>\
                  </div>\
              </div>';
          this.editorEl.innerHTML = snippet;
      },

      closeCreationPanel: function (){
        delete window.createMode;
        document.getElementById('save-btn').textContent = i18n("editor_save_module");
        this.remove();
        delete this.appFragmentId;
        this.toggleCreateMode();
      },

      cancelModuleCreation: function (){
        this.closeCreationPanel();
      },

      toggleCreateMode: function() {
        var isCreateMode = window.createMode;
        $('body').toggleClass("create-mode", isCreateMode);
      },

      removeAppFragment: function(appFragmentJson, options) {
        options = options || {};
        var that = this;
        var application = this.application;
        var persistedStore = application.clientExtensions.getReadonlyAppFragmentStoreV1();
        if(appFragmentJson.id){
          persistedStore.removeById(appFragmentJson.id, {application: application}).then(response => {
            // TODO reload the apps.
            console.log("Removed appFragmentJson with id", appFragmentJson.id, response);
          });
        }
        // For now we just reset the html of the application
      },
        
      loadAppFragment: function(appFragmentJson, options) {
        options = options || {};
        var that = this;
        // For now we just reset the html of the application
        this.application.templateTree.reset(appFragmentJson.htmlFragment,
                                            /* reset callback */
                                            function () {
                                              that.application.options.editAppFragmentJson = appFragmentJson;
                                              // TODO reload once to 
                                              that.globalActions.get("editor_edit_module_properties").set("hidden", false);
                                              that.globalActions.get("editor_global_new").set("hidden", false);
                                              that.application.reload(function () {
                                                if (options.clear) {
                                                  that.remove();
                                                  that.displayAppFragmentEditor(appFragmentJson);
                                                }
                                              });
                                            });
      },

      clearAppFragment: function(options) {
        options = options || {};
        var that = this;
        this.application.templateTree.reset("",
                                            /* reset callback */
                                            function () {
                                              that.application.options.editAppFragmentJson = null;
                                              // TODO reload once to 
                                              that.globalActions.get("editor_edit_module_properties").set("hidden", true);
                                              that.globalActions.get("editor_global_new").set("hidden", false);
                                              that.application.reload();
                                              if (options.clear) {
                                                that.remove();
                                              }
                                            });
      },

      
      saveAppFragmentJsonAsync: function(appFragmentJson) {
        var application = this.application;
        var persistedStore = application.clientExtensions.getReadonlyAppFragmentStoreV1();
        if(appFragmentJson.id){
          return persistedStore.save(appFragmentJson, {application: application});
        }else{
          return persistedStore.create(appFragmentJson, {application: application})
        }
      },


      isAppFragmentBound: function() {
        return this.application.options.appFragmentJson;
      },      
      
      // TODO here we should talk about appfragments.
      createNewModule: function(appFragment) {
        appFragment = appFragment || {};
        var hasAppFragment = !!Object.keys(appFragment).length
        if(hasAppFragment){
          this.appFragmentId = appFragment.id 
        }else{
        }
        this.remove();
        
        this.create();
        window.createMode = true;
        this.addModuleInputFields(appFragment);
        this.toggleCreateMode();
      },

      isValueJSON: function (value) {
        if (!value) return false;
        try {
          JSON.parse(value);
          return true;
        } catch (error) {
          return false;
        }
      },
      
      exportReload: function () {
        var that = this;
        this.application.reload(
          function reloadFinished() {
            that.getContainerWrappedElementByGivenElement('#modal_snippet').modal('show');
          });
        return true;
      },
      
      copyCodeSnippet: function () {
        this.getContainerWrappedElementByGivenElement('.mb-snippet-target').select();
        document.execCommand('copy');
        this.getContainerWrappedElementByGivenElement('.mb-snippet-target').focusout();
      },
      
      clear: function (options) {
        options = options || {};
        if (!options || !options.keepSelectedElementSelected) {
          $(this.application.templateTree.rootNode.el).find(".mb-selected").removeClass("mb-selected");
        }
        
        // remove the editor property
        var model = this.application.models.search;
        if (model.input.get("edit_mode") === true) { 
          model.set({"edit_mode": false}, {unset:true, silent:true});
        }
        
        if (this.templateEditor) {
          this.templateEditor.remove();
          this.templateEditor = null;
        }
        if (this.editorEl) {
          this.editorEl.innerHTML = "";
        }
      },
      
      unselectTemplate: function (template) {
        if (this.templateEditor && this.templateEditor.template === template) {
          this.clear();
        }
        this.remove();
      },
      
      refresh: function (callback) {
        var that = this,
            // TODO: reference search directly? deactivate all models?
            model = this.application.models.search;
        
        if (this.application) this.application.models.stack.popToApplication(this.application);
        
        model.deactivate();
        this.application.templateTree.destroy(function () {
          that.application.updateSnippet();
          that.application.templateTree = new LayoutTree(
            that.application.templateTree.rootEls[0],
            "searchroot",
            null,
            that.application.templateTree.options
          );
          that.application.templateTree.initialize(
            that.application, model, function () {
              if (!model.input.get("edit_mode")) { 
                model.set({"edit_mode": true});
              }
              model.activate();
              if (callback) {callback(that);}
            });
        });
      },
      
      getAdders: function(context) {
        var adders = TemplateRegistry.getAdders(context, this.application);
        return adders;
      },

      remove: function(options) {
        this.clear(options);
        $(this.el).remove();
      }
    });

    Editor.applicationAdditions = {
      editTemplate: function (template) {
        if (this.editor) {
          this.editor.displayEditor(template);
        }
      },

      displayEditor: function(editable) {
        if (this.editor) {
          this.editor.displayEditor(editable);
        }
      },        

      editAppFragment: function (appFragment) {
        var appFragment = appFragment || this.options.editAppFragmentJson;
        if (this.editor) {
          this.editor.displayAppFragmentEditor(appFragment);
        }
      },
      create: function (templateType, options) {
        this.enableState("has-components");
        return TemplateRegistry.create(templateType, options);
      },

      deleteTemplate: function (template) {
        // TODO: move to template?
        this.editor.unselectTemplate(template);
        if (template.el && template.el.parentNode) {
          template.el.parentNode.removeChild(template.el);
        }
        this.reload();
      },

      stopEditing: function() {
        this.editing = false;
        this.trigger("stopEditing");
        this.getContainerWrappedElementByGivenElement("#edit-button").removeClass("active");
      },

      getContainerWrappedElementByGivenElement: function(element) {
        if (element) {
          return $(this.options.containerEl).find(element);
        }
        return this.options.containerEl;
      },

      toggleEditing: function() {
        if (this.editing) {
          this.stopEditing();
        }
        else {
          this.edit();
        }
      },

      isAppFragmentExportType: function () {
        return this.options.exprEnvironment && this.options.exprEnvironment['designerExportType']
         && this.options.exprEnvironment['designerExportType'] === 'AppFragment';
      },

      getSnippet: function ($el) {
        var snippet = $el.html();

        if (this.isAppFragmentExportType()) {
          const viewTemplateEl = $el.find('div[data-template="view"]');
          if (viewTemplateEl.length) {
            snippet = viewTemplateEl[0].innerHTML;
          }
        }

        if(snippet){
          snippet = snippet.replace(/mb-selected|mb-computing/g, "");
        }

        return snippet;
      },

      checkIsDirty: function () {
        if (this.appFragmentHtmlSnippet != null) {
          var isDirty = ((this.options.editAppFragmentJson && this.options.editAppFragmentJson.htmlFragment != this.appFragmentHtmlSnippet)
                         || (!this.options.editAppFragmentJson && _.isEmpty(this.appFragmentHtmlSnippet)));
          this.trigger("dirty", isDirty);
        }
      },
      
      updateSnippet: function () {

        var appFragmentContainerEl = this.templateTree.getAppFragmentContainerEl();
        if (appFragmentContainerEl) {
          this.appFragmentHtmlSnippet = this.getSnippet($(appFragmentContainerEl));
          this.checkIsDirty();
        }
        if(this.options.useShadowRoot){

          this.snippet = this.getSnippet($(this.shadowRoot.querySelector('.mb-snippet-source')));
        }else{

          this.snippet = this.getSnippet($(".mb-snippet-source"));
        }

        var base = url.directory(window.location.protocol + "//" + 
          window.location.host + window.location.pathname) + "../",
            snippet = '<link href="' + base + 'css/v2/adapted.css" rel="stylesheet">' +
            '<div class="mb-body" id="mb-custom-searchapp-wrapper">' +
            this.snippet +
                '</div>' +
                '<script src="' + base + '/../scripts/client.js" data-global-export="false"></script>' +
                '<script>' +
                  'Mindbreeze.require(["client/application"], function(Application) {' +
                    'var application = new Application({' +
                      'rootEl: document.getElementById("mb-custom-searchapp-wrapper")' +
                      (this.options.channels && this.options.channels.length ? 'channels: ' + 
                        JSON.stringify(_.collect(this.options.channels, function (channelUrl) {
                              if (url.isRelative(channelUrl)) {
                                return base + ".." + channelUrl;
                              }
                              return channelUrl;
                        })) : '') +
                    '});' +
                  '});' +
                '</script>';

        this.getContainerWrappedElementByGivenElement(".mb-snippet-target").val(snippet);
      },

      enableState: function (state) {
        $(this.templateTree.rootEls[0]).addClass("mb-" + state);
      },

      disableState: function (state) {
        $(this.templateTree.rootEls[0]).removeClass("mb-" + state);
      },

      hidePicker: function () {
        if (!this.picker) return;

        this.picker.remove();
      },

      showPicker: function (model, parent, insertBefore, sortables) {
        if (this.picker) {
          // TODO: is checking parent enough for determining
          // that we don't need to update picker?
          if (this.picker.options.parent === parent) {
            return;
          }
          this.picker.remove();
        }

        this.picker = new Picker({
          model: model,
          application: this,
          parent: parent,
          insertBefore: insertBefore,
          sortables: sortables
        });

        this.getContainerWrappedElementByGivenElement('#categories').html(this.picker.render().el);
        this.picker.model.trigger("change", this.picker.model.at(0), this.picker.model);
      },

      reload: function(callback) {
        // TODO: reference search directly? deactivate all models?
        var model = this.models.search;
        model.deactivate();
        var that = this;
        model.input.clear();
        this.models.stack.popToApplication(this);

        this.templateTree.reload(this, model,
                                 // reloadcallback
                                 function() {
                                   if (!model.input.get("edit_mode")) { 
                                     model.set({"edit_mode": true});
                                   }
                                   model.activate();
                                   if (callback) {
                                     callback();
                                   }
                                 },
                                 // destroyCallback
                                 function () {
                                   that.updateSnippet();
                                 });
      }
    };
    

    return Editor;
});
